var $b57c0d6f183897e4$exports = {};
$b57c0d6f183897e4$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Selector de culori`,
    "colorSwatch": `specimen de culoare`,
    "transparent": `transparent`,
    "twoDimensionalSlider": `Glisor 2D`
};


export {$b57c0d6f183897e4$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
